export default __webpack_public_path__ + "static/media/Kesariya-Balam-Seema-Mishra.4069487c.mp3";